import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const FORM_ID = 'sftpForm';

export default class STFPForm extends React.Component {
  static propTypes = {
    admin: PropTypes.bool.isRequired,
    closeFunction: PropTypes.func.isRequired,
    createForm: PropTypes.bool.isRequired,
    deleteButtonFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    sftpInfo: PropTypes.object.isRequired,
    submitFunction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  renderCreateForm = () => {
    const { invalid, handleSubmit, submitFunction, submitting, closeFunction } = this.props;

    return (
      <div className="container">
        <p>There is currently no username or password associated with this account. </p>
        <p>
          <i>
            {' '}
            Note: Passwords must contain at least one uppercase letter, one lowercase letter, and
            one number.
          </i>
        </p>
        <fieldset>
          <p>
            <strong>Create SFTP Credentials: </strong>
          </p>
          <Form id={FORM_ID} onSubmit={handleSubmit(submitFunction.bind(this))}>
            <div className="form-group row">
              <div className="col-md-12">
                <Field
                  name="username"
                  type="text"
                  component={InputField}
                  label="Username"
                  autoFocus
                />
              </div>
              <div className="col-md-12">
                <Field
                  name="passwordHash"
                  type="password"
                  component={InputField}
                  label="Password"
                />
                <Field
                  name="confirmPassword"
                  type="password"
                  component={InputField}
                  label="Confirm Password"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-link"
                data-dismiss="modal"
                onClick={closeFunction}
              >
                cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={checkButtonDisabled(invalid, submitting)}
              >
                Create SFTP Credentials
              </button>
            </div>
          </Form>
        </fieldset>
      </div>
    );
  };

  renderButton = () => {
    const { deleteButtonFunction } = this.props;

    return (
      <div className="container">
        <div className="col-md-6">
          <p>Or,</p>
          <button type="submit" className="btn btn-seconday" onClick={deleteButtonFunction}>
            Delete SFTP Credentials
          </button>
        </div>
      </div>
    );
  };

  renderUpdateForm = () => {
    const { sftpInfo } = this.props;

    return (
      <div>
        {sftpInfo.username === ''
          ? this.renderUpdateWithNoCredentials()
          : this.renderUpdateWithCredentials()}
      </div>
    );
  };

  renderUpdateWithNoCredentials = () => (
    <div>
      <p>
        There are currently no SFTP credentials associated with your account <br />
        Please contact Datarista to set up credentials for this account.
      </p>
    </div>
  );

  renderUpdateWithCredentials = () => {
    const {
      admin,
      sftpInfo,
      invalid,
      handleSubmit,
      submitFunction,
      submitting,
      closeFunction,
    } = this.props;

    return (
      <div>
        <p>Current Username: {sftpInfo.username} </p>
        <fieldset>
          <p>
            <strong>Create SFTP Credentials: </strong>
          </p>
          <Form id={FORM_ID} onSubmit={handleSubmit(submitFunction.bind(this))}>
            <div className="form-group row">
              <div className="col-md-12">
                <Field
                  name="username"
                  type="text"
                  component={InputField}
                  label="Username"
                  autoFocus
                />
              </div>
              <div className="col-md-12">
                <Field
                  name="passwordHash"
                  type="password"
                  component={InputField}
                  label="Password"
                />
                <Field
                  name="confirmPassword"
                  type="password"
                  component={InputField}
                  label="Confirm Password"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-link"
                data-dismiss="modal"
                onClick={closeFunction}
              >
                cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={checkButtonDisabled(invalid, submitting)}
              >
                Update SFTP Credentials
              </button>
            </div>
          </Form>
        </fieldset>
        {admin ? this.renderButton() : null}
      </div>
    );
  };

  render() {
    const { createForm } = this.props;

    return <div>{createForm ? this.renderCreateForm() : this.renderUpdateForm()}</div>;
  }
}
